export default {
  getAdminList: {
    method: 'get',
    url: 'admin/list',
    permission: {
      name: "获取管理员列表",
      page: "permissionAdmin",
    }
  },
  addAdmin: {
    method: 'post',
    url: 'admin/add',
    permission: {
      name: "添加管理员",
      page: "permissionAdmin",
    }
  },
  modifyAdmin: {
    method: 'post',
    url: 'admin/mod',
    permission: {
      name: "修改管理员",
      page: "permissionAdmin",
    }
  },
  pwdAdmin: {
    method: 'post',
    url: 'admin/pwd',
    permission: {
      name: "重置管理员密码",
      page: "permissionAdmin",
    }
  },
  deleteAdmin: {
    method: 'post',
    url: 'admin/del',
    permission: {
      name: "删除管理员",
      page: "permissionAdmin",
    }
  },
  getAdminPermission: {
    method: 'get',
    url: 'admin/permission',
    permission: {
      name: "获取管理员权限",
      page: "permissionAdmin",
    }
  },
  getRoleList: {
    method: 'get',
    url: 'role/list',
    permission: {
      name: "获取角色列表",
      page: "permissionRole",
    }
  },
  addRole: {
    method: 'post',
    url: 'role/add',
    permission: {
      name: "添加角色",
      page: "permissionRole",
    }
  },
  modifyRole: {
    method: 'post',
    url: 'role/mod',
    permission: {
      name: "修改角色",
      page: "permissionRole",
    }
  },
  deleteRole: {
    method: 'post',
    url: 'role/del',
    permission: {
      name: "删除角色",
      page: "permissionRole",
    }
  },
  getRolePermission: {
    method: 'get',
    url: 'role/permission',
    permission: {
      name: "获取角色权限",
      page: "permissionRole",
    }
  },
}
